import {
  type OfferV11,
  OfferV1OfferFlagsEnum,
} from '@redteclab/api/clients/bully'

export const productAccessorHasBestOfferFlag = (offer: OfferV11): boolean => {
  return offer.offerFlags?.includes(OfferV1OfferFlagsEnum.BestOffer) ?? false
}
